<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style lang="sass">
  @use './styles/default'
  @use './styles/variables' as v

  #app
    font-family: v.$font-family
    color: v.$dark-white
    height: 100%
    overflow: auto

</style>
